<script setup>
const headerColor = ref('')
const STORAGE_KEY = 'app_header_color'

onMounted(async () => {
  const cachedColor = localStorage.getItem(STORAGE_KEY)
  if (cachedColor) {
    headerColor.value = cachedColor
  }

  const response = await useApi('layouts')
  const color = response?.data?.header_color
  if (color) {
    headerColor.value = `${color}`

    localStorage.setItem(STORAGE_KEY, `${color}`)
  }
})
</script>

<template>
  <div
    class="min-h-screen text-gray-800 relative"
    :style="headerColor ? `background-color: ${headerColor}` : 'background-color: var(--gray-100)'"
  >
    <main class="max-w-7xl mx-auto">
      <slot />
    </main>
  </div>
</template>
